import { FC } from "react"
import ConnectorFormButton from "../../components/ConnectorFormButton"
import LogEntryCard from "./LogEntryCard"

interface IncomingMonitorPanelProps {
  isPolling: boolean
  onStartPolling: () => void
  onStopPolling: () => void
  logsData: any
  expandedLogId: string
  isFetchingRecord: boolean
  recordDetails: any
  onViewRecord: (recordId: string, recordType: string, logId: string) => void
}

const IncomingMonitorPanel: FC<IncomingMonitorPanelProps> = ({
  isPolling,
  onStartPolling,
  onStopPolling,
  logsData,
  expandedLogId,
  isFetchingRecord,
  recordDetails,
  onViewRecord
}) => {
  return (
    <div className="space-y-3">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Monitor Incoming Webhooks
        </label>
        <p className="text-xs text-gray-500 mb-3">
          Monitor for incoming webhook requests. Send a test webhook from your
          CRM to verify.
        </p>

        {!isPolling ? (
          <ConnectorFormButton
            onClick={onStartPolling}
            className="bg-green-600 hover:bg-green-700 border-transparent"
          >
            Start Monitoring
          </ConnectorFormButton>
        ) : (
          <ConnectorFormButton
            onClick={onStopPolling}
            variant="secondary"
            className="bg-gray-600 hover:bg-gray-700 text-white border-transparent"
          >
            Stop Monitoring
          </ConnectorFormButton>
        )}

        {isPolling && (
          <span className="ml-3 text-sm text-green-600 animate-pulse">
            Monitoring for incoming requests...
          </span>
        )}
      </div>

      {/* Recent Logs */}
      {logsData && logsData.logs && logsData.logs.length > 0 && (
        <div className="space-y-2">
          <div className="text-sm font-medium text-gray-700">
            Recent Incoming Requests ({logsData.count})
          </div>
          {logsData.logs.slice(0, 3).map((log: any) => (
            <LogEntryCard
              key={log.id}
              log={log}
              expandedLogId={expandedLogId}
              isFetchingRecord={isFetchingRecord}
              recordDetails={recordDetails}
              onViewRecord={onViewRecord}
            />
          ))}
        </div>
      )}

      {logsData && logsData.logs && logsData.logs.length === 0 && (
        <div className="text-sm text-gray-500 text-center py-4">
          No incoming requests yet. Send a test webhook from your CRM.
        </div>
      )}
    </div>
  )
}

export default IncomingMonitorPanel
